export default {
  default: {
    borderWidth: 2,
    borderColor: 'rgba(113, 185, 0, .5)',
    borderStyle: 'dashed',
    borderRadius: 5,
    width: '100%',
    height: '100%',
  }
}
